import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { sendRequest } from "../../apis/APIs";
import { handleApiResponse } from "../../apis/apiUtils";
import { useSelector, useDispatch } from 'react-redux';
import { callCommonAction } from '../../redux/Common/CommonReducer';
import { useNavigate, useLocation } from 'react-router-dom';
import appRoutes from '../../configs/AppRoutes';
import { validateResetPasswordForm } from "./ValidationResetPassword"

const ResetPassword = () => {
    const [userDetail, setUserDetail] = useState({
        password: '',
        password_confirmation: '',
        email: '',
        token: ''
    });
    const [errorsInfo, setErrorsInfo] = useState({});
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.common);
    const navigate = useNavigate();
    const location = useLocation();

    // Extract token and email from URL on mount
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');
        const email = queryParams.get('email');

        if (token && email) {
            setUserDetail(prev => ({
                ...prev,
                token,
                email
            }));
        } else {
            toast.error("Invalid reset link.");
        }
    }, [location.search]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserDetail({ ...userDetail, [name]: value });

        if (errorsInfo[name]) {
            setErrorsInfo({ ...errorsInfo, [name]: '' });
        }
    };


    const checkFormIsValid = async (fieldName = "") => {
        const res = validateResetPasswordForm(userDetail, fieldName);
        if (fieldName) {
            const error = res.errors[fieldName];
            setErrorsInfo(prev => ({ ...prev, [fieldName]: error || '' }));
        } else {
            setErrorsInfo(res.errors);
        }
        return res.formVaildCheck;
    };

    const sentResetPassword = async (e) => {
        e.preventDefault();
        if (await checkFormIsValid()) {
            try {
                dispatch(callCommonAction({ loading: true }));
                const res = await sendRequest(`/reset-password`, "POST", userDetail);
                handleApiResponse(res);
                if (res.data.type === 'success') {
                    setUserDetail({ password: '', password_confirmation: '', email: '', token: '' });
                    navigate(appRoutes.loginPageRoute);
                }
            } catch (error) {
                dispatch(callCommonAction({ loading: false }));
                toast.error(error?.response?.data?.message || "Something went wrong.");
            }
        }
    };

    return (

        <>

<div className="d-flex justify-content-center w-100 login-main">
                <div className="col-md-12 col-lg-12">
                    <div className="d-flex flex-md-row flex-column shadow rounded overflow-hidden vh-100 align-items-center">
                       
                        
                        <div className="p-4 p-md-6 w-100 px-5">
                            <div className='form-box m-auto'>
                            <div className="d-flex flex-wrap justify-content-center mb-4">
                            <h3 className='text-uppercase'>Reset Password</h3>
                                <p>Enter your new password below.</p>
                            </div>
                            <form noValidate onSubmit={sentResetPassword}>
                                <div className="mb-3">
                                   
                                    <div className='relative'>
                                    <i class="fa-solid fa-key input-i"></i>
                                    <input
                                        type="password"
                                        placeholder='New Password'
                                        name="password"
                                        id="password"
                                        className="form-control"
                                        value={userDetail.password}
                                        onChange={handleChange}
                                        onBlur={() => checkFormIsValid("password")}
                                    />
                                    </div>
                                    {errorsInfo.password && (<p className="text-danger">{errorsInfo.password}</p>)}
                                </div>

                                <div className="mb-3">
                                   
                                    <div className='relative'>
                                    <i class="fa-solid fa-key input-i"></i>
                                    <input
                                        type="password"
                                         placeholder='Confirm Password'
                                        name="password_confirmation"
                                        id="password_confirmation"
                                        className="form-control"
                                        value={userDetail.password_confirmation}
                                        onChange={handleChange}
                                        onBlur={() => checkFormIsValid("password_confirmation")}
                                    />
                                    </div>
                                    {errorsInfo.password_confirmation && (<p className="text-danger">{errorsInfo.password_confirmation}</p>)}
                                </div>

                                <div className="text-center mb-3">
                                    <button type="submit" disabled={loading} className="w-100 btn-lg btn-primary shadow btn btn-primary btn-yellow">
                                        {
                                            loading
                                                ? <span className="indicator-progress" style={{ display: 'block' }}>
                                                    Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                                : <span className="indicator-label">Submit</span>
                                        }
                                    </button>
                                </div>

                                <div className="d-flex justify-content-center align-items-center mb-3 text-center">
                                    <a href="#" className="text-decoration-none border-btn d-block w-100 rounded btn-lg py-2 btn-grey shadow btn btn-primary" onClick={(e) => {
                                        e.preventDefault();
                                        navigate(appRoutes.loginPageRoute);
                                    }}>
                                        Back to Login
                                    </a>
                                </div>
                            </form>
                        </div>
                        </div>

                        <div className="w-100 p-15 vh-100 form-right d-flex align-items-center justify-content-center">
                       
                       <div className='login-right-inner text-center'> 
                        <span className='d-block mb-4'><img src="./assets/images/image.png" alt="No Data Found"/></span>
                        <img src="./assets/images/login-img.png" alt="No Data Found"/>
                        <h3 className='mt-4 text-white'>Document Selection and Aggregation Tool</h3>
                        <p className='fs-6 text-white mt-3'>A <b>PDF builder</b> tool that allows users to create <b>customized</b> PDFs by selecting pages from multiple <b>PDF</b> files and adding new content through an integrated form interface.</p>
                        </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    );
};

export default ResetPassword;
